import Component from '../colorz/Component';
import device   from '../colorz/utils/device';
import Flickity from 'flickity-imagesloaded';

/*
* FP Live
*/

module.exports = class FPlive extends Component{
    onInit( el, args ) {
        this.el = el;
    }

    onReady() {

        this.initSlider();

        // disable horizontal scroll
        document.body.classList.add('js-has-flickity');
    }

    initSlider(){
        var options = {
            cellSelector: '.js-slide',
            imagesLoaded: true,
            pageDots: true,
            cellAlign : 'left',
            prevNextButtons: false,
            draggable: true,
            autoPlay: 5000,
            selectedAttraction: 0.05,
            friction: 0.8,
            wrapAround: true
        };

        // init slider
        this.slider = new Flickity(this.el, options);

    }

};
